import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 184 1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, #051524)",
      "stroke-opacity": ".06",
      d: "M0 .5h184"
    }, null, -1)
  ]))]))
}
export default { render: render }